// extracted by mini-css-extract-plugin
export default {"container":"TextBox_container__-3S0V","label":"TextBox_label__9xR6D","value":"TextBox_value__MYfBw"};